"use client";

import { Icon } from "./Home";

export default function WhyDiriyah({ isAr }: { isAr: boolean }) {
  const t = (a: string, e: string) => (isAr ? a : e);

  const features = [
    {
      icon: "verified_user",
      title: t("تأكيد فوري", "Instant confirmation"),
      desc: t(
        "احجز بضغطة زر واحصل على تأكيدك مباشرة دون انتظار.",
        "Book with one tap and get confirmed instantly.",
      ),
    },
    {
      icon: "event_available",
      title: t("إلغاء مجاني", "Free cancellation"),
      desc: t(
        "مرونة كاملة في الإلغاء قبل الموعد المحدد دون رسوم.",
        "Full flexibility to cancel before your date, fee-free.",
      ),
    },
    {
      icon: "workspace_premium",
      title: t("ضيافة متميزة", "Outstanding hospitality"),
      desc: t(
        "جودة عالمية بهوية وأصالة سعودية",
        "World-class quality with an authentic Saudi identity",
      ),
    },
    {
      icon: "support_agent",
      title: t("دعم 24/7", "24/7 support"),
      desc: t(
        "فريقنا متواجد على مدار الساعة لتجربة استثنائية.",
        "Our team is here around the clock for you.",
      ),
    },
  ];

  return (
    <section className="py-20 bg-clay-50 border-y border-clay-100">
      <div className="px-6 container mx-auto">
        <h2 className="font-display text-4xl font-bold text-center mb-14 text-clay-600">
          {t("لماذا منازل الدرعية؟", "Why Diriyah Homes?")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-center">
          {features.map((f) => (
            <div key={f.icon}>
              <div className="w-20 h-20 bg-surface rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-sm">
                <Icon name={f.icon} className="text-clay-600 text-4xl" />
              </div>
              <h3 className="font-bold text-xl mb-3 text-ink-900">{f.title}</h3>
              <p className="text-ink-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
